/* sk-withdrawal v2 — showTitle-Option: die umgebende Karte traegt die Ueberschrift */
(function () {
  "use strict";

  var cfg = window.__SK_WITHDRAWAL_CONFIG || {};
  var API = cfg.apiUrl || "https://erp-api-289183413262.europe-west1.run.app";
  var t = cfg.text || {};

  var decoder = document.createElement("textarea");

  function decodeEntities(value) {
    if (typeof value !== "string" || value.indexOf("&") === -1) return value;
    decoder.innerHTML = value;
    return decoder.value;
  }

  function txt(key, fallback) {
    // Der Liquid-t-Filter escaped Uebersetzungen (l'etape -> l&#39;etape). Da die
    // Texte hier per textContent gesetzt werden, muss das zurueckgedreht werden.
    return decodeEntities(t[key] || fallback);
  }

  var state = {
    step: 1,
    sessionId: null,
    sessionToken: null,
    data: null,
    loading: false,
    done: false,
  };

  var root;

  function injectStyles() {
    if (document.getElementById("sk-withdrawal-runtime-styles")) return;
    var style = document.createElement("style");
    style.id = "sk-withdrawal-runtime-styles";
    style.textContent =
      ".sk-wd__card{padding:var(--sk-space-xl);border:1px solid var(--sk-border);border-radius:var(--sk-radius-md);background:var(--sk-bg-white);box-shadow:var(--sk-shadow-md)}" +
      ".sk-wd__title{margin:0 0 var(--sk-space-md);font-family:var(--sk-font-heading);font-size:var(--sk-text-h2);font-weight:800;line-height:1.25;color:var(--sk-primary)}" +
      ".sk-wd__intro{margin:0 0 var(--sk-space-lg);font-size:1rem;line-height:1.6;color:var(--sk-text-secondary)}" +
      ".sk-wd__form{display:grid;gap:var(--sk-space-md)}" +
      ".sk-wd__label{display:grid;gap:var(--sk-space-sm);font-size:.9rem;font-weight:700;color:var(--sk-primary)}" +
      ".sk-wd__input{width:100%;min-height:46px;padding:var(--sk-space-sm) var(--sk-space-md);border:1px solid var(--sk-border);border-radius:var(--sk-radius-sm);font:inherit;color:var(--sk-text);background:var(--sk-bg-white);box-sizing:border-box}" +
      ".sk-wd__input:focus{outline:3px solid var(--sk-gold);outline-offset:3px}" +
      ".sk-wd__btn{display:inline-flex;align-items:center;justify-content:center;min-height:46px;padding:var(--sk-space-sm) var(--sk-space-lg);border:1px solid transparent;border-radius:var(--sk-radius-sm);cursor:pointer;font-family:var(--sk-font-heading);font-size:1rem;font-weight:800;line-height:1.2}" +
      ".sk-wd__btn--primary{background:var(--sk-accent);color:var(--sk-bg-white)}" +
      ".sk-wd__btn--primary:hover{background:var(--sk-secondary)}" +
      ".sk-wd__btn--primary:disabled{cursor:not-allowed;background:var(--sk-border);color:var(--sk-text-secondary)}" +
      ".sk-wd__btn--secondary{border-color:var(--sk-primary);background:var(--sk-bg-white);color:var(--sk-primary)}" +
      ".sk-wd__actions{display:grid;gap:var(--sk-space-md);margin-top:var(--sk-space-lg)}" +
      ".sk-wd__review,.sk-wd__success{padding:var(--sk-space-md);border-radius:var(--sk-radius-sm);background:var(--sk-bg-light);font-size:1rem;line-height:1.6}" +
      ".sk-wd__review{border:1px solid var(--sk-gold-light);color:var(--sk-text)}" +
      ".sk-wd__success{border:1px solid var(--sk-accent);color:var(--sk-primary)}" +
      ".sk-wd__error{margin-bottom:var(--sk-space-md);color:var(--sk-gold-hover);font-size:.95rem;font-weight:700}" +
      "@media (min-width:768px){.sk-wd__form{grid-template-columns:repeat(2,minmax(0,1fr))}.sk-wd__form .sk-wd__label:nth-child(3),.sk-wd__form .sk-wd__btn{grid-column:1/-1}.sk-wd__actions{grid-template-columns:repeat(2,minmax(0,1fr))}}" +
      "@media (max-width:768px){.sk-wd__card{padding:var(--sk-space-lg)}.sk-wd__title{font-size:var(--sk-text-h3)}}";
    document.head.appendChild(style);
  }

  function api(path, opts) {
    var headers = { "Content-Type": "application/json" };
    if (opts && opts.auth) headers.Authorization = "Bearer " + state.sessionToken;
    return fetch(API + path, {
      method: (opts && opts.method) || "GET",
      headers: headers,
      body: opts && opts.body ? opts.body : undefined,
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error((err.error && err.error.message) || txt("error_send", "Fehler " + res.status));
        });
      }
      return res.json();
    });
  }

  function el(tag, cls) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    return node;
  }

  function showError(msg) {
    var box = root.querySelector(".sk-wd__error");
    if (!box) return;
    box.textContent = msg;
    box.hidden = !msg;
  }

  function render() {
    root.innerHTML = "";

    if (state.done) {
      var ok = el("div", "sk-wd__success");
      ok.setAttribute("role", "status");
      ok.textContent = txt(
        "success",
        "Vielen Dank. Wir haben deinen Widerruf erhalten und dir eine Bestätigung per E-Mail gesendet."
      );
      root.appendChild(ok);
      return;
    }

    /* showTitle:false — die umgebende Karte traegt bereits eine Ueberschrift */
    if (cfg.showTitle !== false) {
      var title = el(cfg.headingTag || "h2", "sk-wd__title");
      title.textContent = txt("page_title", "Hier vom Vertrag widerrufen");
      root.appendChild(title);
    }

    var intro = el("p", "sk-wd__intro");
    intro.textContent = txt(
      "intro",
      "Du kannst deinen Widerruf auf dieser Seite erklären. Bitte prüfe deine Angaben im zweiten Schritt, bevor du den Widerruf verbindlich absendest."
    );
    root.appendChild(intro);

    var error = el("div", "sk-wd__error");
    error.hidden = true;
    root.appendChild(error);

    if (state.step === 1) {
      var form = el("form", "sk-wd__form");
      form.innerHTML =
        '<label class="sk-wd__label">' +
        txt("name_label", "Dein Name") +
        '<input class="sk-wd__input" name="name" autocomplete="name" required></label>' +
        '<label class="sk-wd__label">' +
        txt("email_label", "E-Mail-Adresse") +
        '<input class="sk-wd__input" name="email" type="email" autocomplete="email" required></label>' +
        '<label class="sk-wd__label">' +
        txt("order_label", "Bestellnummer") +
        '<input class="sk-wd__input" name="orderNumber" autocomplete="off" inputmode="numeric" required placeholder="#105123"></label>';

      if (cfg.customer) {
        if (cfg.customer.name && form.elements.name) form.elements.name.value = cfg.customer.name;
        if (cfg.customer.email && form.elements.email) form.elements.email.value = cfg.customer.email;
      }

      var nextBtn = el("button", "sk-wd__btn sk-wd__btn--primary");
      nextBtn.type = "submit";
      nextBtn.textContent = txt("next", "Weiter");
      form.appendChild(nextBtn);

      form.onsubmit = function (ev) {
        ev.preventDefault();
        showError("");
        var name = form.elements.name.value.trim();
        var email = form.elements.email.value.trim();
        var orderNumber = form.elements.orderNumber.value.trim();
        if (name.length < 2) {
          showError(txt("error_name", "Bitte gib deinen Namen an."));
          return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showError(txt("error_email", "Bitte gib eine gültige E-Mail-Adresse an."));
          return;
        }
        if (orderNumber.length < 4) {
          showError(txt("error_order", "Bitte gib deine Bestellnummer an."));
          return;
        }
        state.data = { name: name, email: email, orderNumber: orderNumber };
        state.step = 2;
        render();
      };

      root.appendChild(form);
      return;
    }

    var review = el("div", "sk-wd__review");
    review.innerHTML =
      "<strong>" +
      txt("review_title", "Bitte prüfe deine Angaben:") +
      "</strong><br><br>" +
      txt("name_label", "Dein Name") +
      ": " +
      escapeHtml(state.data.name) +
      "<br>" +
      txt("email_label", "E-Mail-Adresse") +
      ": " +
      escapeHtml(state.data.email) +
      "<br>" +
      txt("order_label", "Bestellnummer") +
      ": " +
      escapeHtml(state.data.orderNumber) +
      "<br><br>" +
      escapeHtml(txt("review_hint", "Wenn alles stimmt, sende den Widerruf im nächsten Schritt verbindlich ab."));
    root.appendChild(review);

    var actions = el("div", "sk-wd__actions");
    var backBtn = el("button", "sk-wd__btn sk-wd__btn--secondary");
    backBtn.type = "button";
    backBtn.textContent = txt("back", "Zurück");
    backBtn.onclick = function () {
      state.step = 1;
      showError("");
      render();
    };

    var submitBtn = el("button", "sk-wd__btn sk-wd__btn--primary");
    submitBtn.type = "button";
    submitBtn.disabled = state.loading;
    submitBtn.textContent = state.loading
      ? txt("submitting", "Wird gesendet...")
      : txt("submit", "Widerruf verbindlich absenden");
    submitBtn.onclick = submitWithdrawal;

    actions.appendChild(backBtn);
    actions.appendChild(submitBtn);
    root.appendChild(actions);
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function ensureSession() {
    if (state.sessionId && state.sessionToken) return Promise.resolve();
    return api("/chat/sessions", {
      method: "POST",
      body: JSON.stringify({
        visitorPage: window.location.href,
        visitorEmail: state.data.email,
        visitorName: state.data.name,
      }),
    }).then(function (res) {
      state.sessionId = res.data.sessionId;
      state.sessionToken = res.data.sessionToken;
    });
  }

  function submitWithdrawal() {
    if (!state.data || state.loading) return;
    showError("");
    state.loading = true;
    render();

    ensureSession()
      .then(function () {
        return api("/chat/sessions/" + state.sessionId + "/withdrawal", {
          method: "POST",
          auth: true,
          body: JSON.stringify({
            name: state.data.name,
            email: state.data.email,
            orderNumber: state.data.orderNumber,
            confirmed: true,
          }),
        });
      })
      .then(function () {
        state.loading = false;
        state.done = true;
        render();
      })
      .catch(function (err) {
        state.loading = false;
        render();
        showError(err.message || txt("error_send", "Widerruf konnte nicht gesendet werden."));
      });
  }

  function init() {
    root =
      document.querySelector(".sk-withdrawal-layout-inline .sk-withdrawal-inline-v2 #sk-withdrawal-root") ||
      document.querySelector(".sk-withdrawal-inline-v2 #sk-withdrawal-root") ||
      document.getElementById("sk-withdrawal-root");
    if (!root) return;
    injectStyles();
    render();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
